import styled from "styled-components";

const CustomButton = styled.button`
  width: 100%;
  padding: 15px 0;
  border-radius: 30px;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  background: ${({ disabled }) => disabled ? '#BDBDC1' : '#222224'};
  background: ${({ isCancel }) => isCancel && '#ECEDF0'};
  color: ${({ isCancel }) => isCancel ? '#222224' : '#fff' };
  margin-top: 15px;
`
const ModalHeader = styled.div`
font-weight: 700;
font-size: 24px;
line-height: 29px;
text-align: center;
margin: 20px 0 25px;
`;

const SimpleText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 30px;
`

export const GratitudeContainer = ({handleModalClose}) => {
  return (
    <>
      <ModalHeader>Thank you!</ModalHeader>
      <SimpleText>Thanks for letting us know your church isn’t showing in Togather. We’ll look into it and reach out with further updates.</SimpleText>
      <CustomButton onClick={handleModalClose}>Got it, thanks!</CustomButton>
    </>
  )
}